var disabledAnimateAjax = false;

// Google Translate: u filtru značky/modelu nesmí docházet k překladu – přeložená
// hodnota optionu se propisuje do URL výpisu. Označíme původní <select> (notranslate
// se dědí i na AJAX doplněné optiony modelu) i select2 container/dropdown, které
// select2 generuje dynamicky (při načtení stránky ještě neexistují).
function markBrandModelNoTranslate($selects) {
    $selects.addClass('notranslate').attr('translate', 'no');
    $selects.each(function () {
        var inst = $(this).data('select2');
        if (!inst) {
            return;
        }
        if (inst.$container) {
            inst.$container.addClass('notranslate').attr('translate', 'no');
        }
        if (inst.$dropdown) {
            inst.$dropdown.addClass('notranslate').attr('translate', 'no');
        }
    });
}
// webpack modul – ať je helper dostupný i z search.js (initMultiSelect)
window.markBrandModelNoTranslate = markBrandModelNoTranslate;

$(document).ready(function () {
    var self = this;

    $.nette.init();

    window.app = new App();
    window.app.init();

    $.nette.ext('reload', {
        before: function () {
            window.app.beforeReload();
        },
        success: function () {
            window.app.reload();
        }
    }, {});
});

var App = function () {}

App.prototype.init = function () {
    this.initWebStaffs();
    this.initNotifications();
    this.initFormErrorsModal();
    this.initComponents();
    this.initAnimatedAjax();
    this.initFakeUrlClick();
    this.initGMap();
    this.initMapMarkers();
    this.initCountdown();
    this.initOwnButtons();
    this.initCompare();
    this.initCopyLink();
    this.initGallery();
    this.initScrollNav();
    this.initBtnShowRecommendCars();
    this.initBtnShowArticleText();
    this.initTippy();
    this.initKoop();
    this.initDateTimePicker();
    this.initSelectAjax();
    this.initPopupCebia();
    this.initPopupCo2();

    // Re-pozicování při resize
    var self = this;
    $(window).on('resize', function() {
        self.initMapMarkers();
    });

    if ($('.initReviews').length) {
        window.reviews = new Reviews();
        window.reviews.init();
    }

    $('.video-show').off('click').on('click', function (e) {
        e.preventDefault();
        $.nette.ajax({
            url: $(this).data('url'),
        }).done(function () {
            $('#videoModal').modal('show');
            $('#videoModal').on('hidden.bs.modal', function () {
                $('#videoModal video').remove();
            })
        });
    });

    $('.btn-video-close').off('click').on('click', function (e) {
        $('#videoModal').modal('hide');
        $('#videoModal video').remove();
    });


    if ($('.premium_description__gallery').length) {
        $('.premium_description__gallery .mfp-gallery').magnificPopup({
            delegate: 'a.mfp-image',
            type: 'image',
            gallery: {
                enabled: true
            }
        });
    }
}

App.prototype.initDateTimePicker = function () {
    $('.datepicker').datetimepicker({
        format: 'L',
        locale: 'cs',
        // icons: {
        //     time: 'zmdi zmdi-time',
        //     date: 'zmdi zmdi-calendar',
        //     up: 'zmdi zmdi-chevron-up zmdi-hc-2x',
        //     down: 'zmdi zmdi-chevron-down zmdi-hc-2x',
        //     previous: 'zmdi zmdi-chevron-left zmdi-hc-2x',
        //     next: 'zmdi zmdi-chevron-right zmdi-hc-2x',
        //     today: 'zmdi zmdi-gps-dot zmdi-hc-2x',
        //     clear: 'zmdi zmdi-delete zmdi-hc-2x',
        //     close: 'zmdi zmdi-close'
        // }
    });
};

App.prototype.initSelectAjax = function () {
    $('.selectAjaxInit').off('change').on('change', function () {
        $.nette.ajax($(this).data('link').replace('-id-', $(this).val()));
    });
};

App.prototype.beforeReload = function () {
    if ($('.initSearchFull').length) {
        this.destroyCountdown();
    }

    if ($('.overlayContentRemoveContent').length && !$('.overlayContentRemoveContent .loader-wrapper').length) {
        $('.overlayContentRemoveContent').html('');
        var html = '<div class="loader-wrapper"><div class="loader-circle-wrapper"><div class="loader-circle"></div></div></div>';
        $('.overlayContentRemoveContent').prepend(html);
        $('html, body').animate({
            scrollTop: $(".overlayContentRemoveContent").offset().top - 40
        }, 500);
    }
}

App.prototype.reload = function () {
    if ($('.initSearchFull').length) {
        window.search.reload();
    }

    if ($('.initSearchLight').length) {
        window.searchLight.reload();
    }

    if ($('.initEshop').length) {
        window.eshop = new Eshop();
        window.eshop.reload();
    }

    window.forms = new Forms();
    window.forms.reload();

    this.initFormErrorsModal();
    this.initCountdown();
    this.initCompare();
    this.showVin();
    this.initOpenFile();
    this.initBtnShowRecommendCars();

    $('.overlayContentRemoveContent .loader-wrapper').remove();


}

App.prototype.initBtnShowArticleText = function () {
    if ($(".showArticleText").length) {
        $('.showArticleText').off('click').on('click', function () {
            $('.articleText').removeClass('d-none');
            $(this).parent().remove();
        });
    }
}

App.prototype.initBtnShowRecommendCars = function () {
    if ($(".btnShowRecommendCars").length) {
        $('.btnShowRecommendCars').off('click').on('click', function () {
            $('.pagination').removeClass('d-none');
            $('.car_item').removeClass('d-none');
            $(this).remove();
        });
    }
}

App.prototype.initGallery = function () {
    $('.initGallery').magnificPopup({
        delegate: 'a.gallery-photo',
        type: 'image',
        gallery: {
            enabled: true
        },
    });
}

App.prototype.showVin = function () {
    if ($("#showVin").length) {
        // console.log();
        $('.show-vin').removeClass("clone");
        $('.show-vin .detail_attr__options__text').text("VIN: " + $("#showVin").val());
        $('.show-vin .detail_attr__options__icon').remove();
    }
}

App.prototype.initOpenFile = function () {
    if ($("#openFile").length) {
        window.open($("#openFile").val(), '_blank').focus();
    }
}

App.prototype.initCompare = function () {
    if ($(".comparsion-holder").length) {
        var maxHeight = 0;
        $('.porovnavac_content .three_line_box').each(function (index) {
            if (maxHeight < $(this).height()) {
                maxHeight = $(this).height();
            }
        });

        $('.porovnavac_content .three_line_box').height(maxHeight);
        $('.title_column .three_line_box').height(maxHeight);

        // return;
        $('.porovnavac_content').slick({
            infinite: true,
            speed: 250,
            dots: true,
            variableWidth: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: $('.navigation_href.prev'),
            nextArrow: $('.navigation_href.next'),
            responsive: [{
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {}
                },
                {
                    breakpoint: 480,
                    settings: {}
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
        });
    }
}

App.prototype.initOwnButtons = function () {
    var isLoaded = null;

    $("#interiorModal").on('shown.bs.modal', function () {
        if (isLoaded === null) {
            isLoaded = pannellum.viewer('interiorView', {
                "type": "equirectangular",
                "panorama": $('.own-button-interior').data('url'),
                "autoLoad": true
            });
        }
    });

    $('.own-button-video').off('click').on('click', function (e) {
        e.preventDefault();
        $.nette.ajax({
            url: $(this).data('url'),
        }).done(function () {
            $('#videoModal').modal('show');
            $('#videoModal').on('hidden.bs.modal', function () {
                $('#videoModal video').remove();
            })
        });
    });

    $('.btn-video-close').off('click').on('click', function (e) {
        $('#videoModal').modal('hide');
        $('#videoModal video').remove();
    });
};

App.prototype.initComponents = function () {
    if ($('.initSearch').length || $('.initSearchFull').length) {
        window.search = new Search();
        window.search.init();
    }

    if ($('.initSearchLight').length) {
        window.searchLight = new SearchLight();
        window.searchLight.init();
    }

    if ($('.initInstallmentCalculator').length) {
        window.installmentCalculator = new InstallmentCalculator();
        window.installmentCalculator.init();
    }

    if ($('.initCarDetail').length) {
        window.carDetail = new CarDetail();
        window.carDetail.init();
    }

    if ($('.initEshop').length) {
        window.eshop = new Eshop();
        window.eshop.init();
    }

    window.forms = new Forms();
    window.forms.init();
}

App.prototype.initCopyLink = function () {
    $('.copyLink').off('click').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val($(this).attr('href')).select();
        document.execCommand("copy");
        $temp.remove();
    });
}

App.prototype.initFakeUrlClick = function () {
    $(".fake-url-click").off('click').on('click', function (event) {
        if (event.target.nodeName != 'A') {
            if (event.ctrlKey) {
                window.open($(this).data("url"), '_blank');
            } else {
                window.location.href = $(this).data("url");
                return false;
            }
        }
    });
    $(".fake-modal-click").off('click').on('click', function (event) {
        $($(this).data('target')).modal('show');
        return false;
    });
}

App.prototype.initAnimatedAjax = function () {
    var self = this;

    $('.animateFormSend').off('click').on('click', function (event) {
        if ($('.animateFormSend').closest('form').length) {
            event.preventDefault();
            if (Nette.validateForm(this)) {
                $('.animateFormSend').prepend('<span class="fa fa-spinner fa-spin"></span>');
                $('.animateFormSend').addClass("disabled");

                $('.animateFormSend').closest('form').submit();
            }
        } else {
            $('.animateFormSend').prepend('<span class="fa fa-spinner fa-spin"></span>');
            $('.animateFormSend').addClass("disabled");
        }
    });

    $.nette.ext('animateAjax', {
        before: function () {
            if (!disabledAnimateAjax) {
                $('.animateAjax').prepend('<span class="fa fa-spinner fa-spin"></span>');
                $('.animateAjax').prop("disabled", true);
            }

            if ($('.initOverlayContent').length) {
                self.prependOverlayContent();
            }
        },
        success: function () {
            $('.animateAjax').find('.fa').remove();
            $('.animateAjax').prop("disabled", false);
            $('.animateAjaxClick').find('.fa').remove();
            $('.animateAjaxClick').prop("disabled", false);
            $('.animateAjaxSearch').prop("disabled", false);
            $('.overlayContent .loader-wrapper').remove();
            $('.animateFormSend .fa-spinner').remove();
            disabledAnimateAjax = false;


            $('.animateAjaxClick').off('focus').on('focus', function () {
                $(this).prepend('<span class="fa fa-spinner fa-spin"></span>');
                $(this).prop("disabled", true);
                $(this).trigger('submit');
            });
        }
    }, {});
}

App.prototype.initFormErrorsModal = function () {
    if ($.trim($("#formErrorsModal").find('.modal-body').html()) != '') {
        $("#formErrorsModal").modal('show');
    }
}

App.prototype.initWebStaffs = function () {
    // var interval = setInterval(function () {
    //     if (exponea.configuration !== undefined) {
    //         console.log('exponea.configuration.customer.cookie');
    //         console.log(exponea.configuration.customer.cookie);
    //         $('input[name=cookieConsent]').each(function () {
    //             $(this).val(exponea.configuration.customer.cookie);
    //         });
    //         clearInterval(interval);
    //     }
    // }, 500);

    $('#autocomplete').autocomplete({
        serviceUrl: $('#autocomplete').data('link'),
        minChars: 3,
        groupBy: 'category',
        onSelect: function (suggestion) {
            window.location = suggestion.data.link;
        },
    });

    $(window).on("hashchange", function () {
        //                if ($("#car-detail").length) {
        //                        dataLayer.push({
        //                                "rtbCarID": $("#car-detail").data('webid'),
        //                                "page.Type": "other"
        //                        });
        //                }else{
        //                      dataLayer.push({
        //                                "page.Type": "other"
        //                        });
        //                }

        ga('send', 'pageview', location.pathname + location.search + location.hash);
        ga('send', 'pageview', location.pathname + location.search + location.hash.replace('#', '/'));
    });

    $('#branch-redirect-form .btn').off('click').on('click', function () {
        var branch = $('#branch-redirect-form select').select2('val');
        if (branch !== '') {
            window.location.href = $('#branch-redirect-form select option[value="' + branch + '"]').data('href');
        }
    });

    $('#branch-redirect-form-old .btn').off('click').on('click', function () {
        var branch = $('#branch-redirect-form-old select').select2('val');
        if (branch !== '') {
            window.location.href = $('#branch-redirect-form-old select option[value="' + branch + '"]').data('href');
        }
    });

    $('#main-video').off('click').on('click', function () {
        $('#main-video').remove();
        $('#player').css('display', 'block');
        var video = document.getElementById("main-video-player");
        video.play();
        // var videos = document.querySelectorAll("video");
        // for (var video in videos) {
        //     video.play();
        // }
    });

    // menu toggler
    $('.menu_toggler').click(function () {
        $(this).toggleClass("active");
        $(".main_menu").fadeToggle();
    })

    $('.mapClick').click(function () {
        $('html, body').animate({
            scrollTop: $(".branchSelect").offset().top - 200
        }, 500, function () {
            $(".branchSelect").select2('open');
        });
    })

    if ($('#disclaimer').length) {
        $('.showDisclaimer').click(function (e) {
            var offset = $('body').width() > 950 ? 140 : 20
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $("#disclaimer").offset().top - offset
            }, 500);
        })
    }

    // submenu toggler
    $('.submenu_toggler').click(function () {
        var parent_el = $(this).closest("li");
        $(parent_el).toggleClass("submenu_show")
        $("ul", parent_el).slideToggle();
    })

    // search toggler
    $('.header_right a.search').click(function () {
        $(this).toggleClass("active");
        $(".search_form_line").toggleClass("active");
        $(".search_form_line #autocomplete").focus();
        return false;
    })

    $('.search_form_line .close_search').click(function () {
        $(".header_right a.search").removeClass("active");
        $(".search_form_line").removeClass("active");
    })

    if ($(".main_slider").length) {
        // slider init
        $('.main_slider').slick({
            infinite: true,
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000
        });


        $('.main_slider__slide_video').off('click').on('click', function () {
            if ($(this).find('#player2').length) {
                return;
            }

            $(this).find('.container').remove();
            $(this).find('a').remove();
            $(this).addClass('main_slider__slide_video_play');

            var player = '<div id="player2">' +
                '<video id="main-video-player2" autoplay>' +
                '<source src="' + $(this).data('video') + '" type="video/mp4">' +
                'Your browser does not support the video tag.' +
                '</video>' +
                '</div>';

            $(this).append(player);
            video = document.getElementById("main-video-player2");
            video.play();
        });
    }

    if ($(".main_slider_mobile").length) {
        // slider init
        $('.main_slider_mobile').slick({
            infinite: true,
            dots: true,
            arrows: true,
            prevArrow: $('#main_slider__arrow--left'),
            nextArrow: $('#main_slider__arrow--right'),
            autoplay: false,
            autoplaySpeed: 7000
        });
        $(".main_slider_mobile .slick-dots").insertAfter(".main_slider--holder .dots_and_arrows_holder #main_slider__arrow--left");
    }

    if ($(".gallery-header").length && $('body').width() < 959) {
        // slider init
        $('.gallery-header').slick({
            infinite: true,
            dots: false,
            arrows: false,
            // dots: true,
            // arrows: true,
            // prevArrow: $('#main_slider__arrow--left'),
            // nextArrow: $('#main_slider__arrow--right'),
            autoplay: true,
            autoplaySpeed: 2000
        });
        $(".main_slider_mobile .slick-dots").insertAfter(".main_slider--holder .dots_and_arrows_holder #main_slider__arrow--left");
    }

    if ($("#car_slider_1").length) {
        // car slider 1
        $('#car_slider_1 .items_slider').slick({
            infinite: true,
            dots: true,
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            variableWidth: true,
            prevArrow: $('#car_slider_1 .styled_slider_arrow--left'),
            nextArrow: $('#car_slider_1 .styled_slider_arrow--right'),
            appendDots: $("#car_slider_1 .slider_flat_dots"),
            responsive: [{
                breakpoint: 960,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 3,
                }
            }]
        });
    }


    if ($("#car_slider_2").length) {
        // car slider 2
        $('#car_slider_2 .items_slider').slick({
            infinite: true,
            dots: true,
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            variableWidth: true,
            prevArrow: $('#car_slider_2 .styled_slider_arrow--left'),
            nextArrow: $('#car_slider_2 .styled_slider_arrow--right'),
            appendDots: $("#car_slider_2 .slider_flat_dots"),
            responsive: [{
                breakpoint: 960,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 3,
                }
            }]
        });
    }


    // if ($("#highlited_cars_slider").length) {
    //     // highlited cars slider
    //     $('#highlited_cars_slider .cars_card_slider').slick({
    //         infinite: true,
    //         dots: true,
    //         arrows: true,
    //         slidesToScroll: 3,
    //         slidesToShow: 3,
    //         variableWidth: true,
    //         prevArrow: $('#highlited_cars_slider .styled_slider_arrow--left'),
    //         nextArrow: $('#highlited_cars_slider .styled_slider_arrow--right'),
    //         appendDots: $("#highlited_cars_slider .slider_flat_dots"),
    //         responsive: [{
    //                 breakpoint: 1270,
    //                 settings: {
    //                     slidesToScroll: 2,
    //                     slidesToShow: 2,
    //                 }
    //             },
    //             {
    //                 breakpoint: 680,
    //                 settings: {
    //                     slidesToScroll: 1,
    //                     slidesToShow: 1,
    //                     centerMode: true,
    //                 }
    //             }
    //         ]
    //     });
    // }

    // console.log($(window).width());
    var initIn = $('.car-not-found .slider-mobile').length ? 749 : 600;
    if ($(".slider-mobile").length && $(window).width() < initIn) {
        $(".slider-mobile").each(function () {
            console.log($(this));
            console.log($(this).hasClass('slider-mobile-double'));
            $(this).find('.slider-mobile-wrapper').slick({
                infinite: true,
                dots: true,
                arrows: true,
                slidesToShow: $(this).hasClass('slider-mobile-double') ? 2 : 1,
                slidesToScroll: 1,
                // variableWidth: true,
                prevArrow: $(this).closest('.slider-mobile').find('.slider-mobile-navigation .slider-mobile-arrow-left'),
                nextArrow: $(this).closest('.slider-mobile').find('.slider-mobile-navigation .slider-mobile-arrow-right'),
                appendDots: $(this).closest('.slider-mobile').find(".slider-mobile-navigation .slider-mobile-dots"),
            })
        });
    }

    if ($(".blog-article-slider-wrapper").length) {
        // highlited cars slider
        $('.blog-article-slider-wrapper .blog-article-slider').slick({
            infinite: true,
            dots: true,
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            // variableWidth: true,
            prevArrow: $('.blog-article-slider-wrapper .styled_slider_arrow--left'),
            nextArrow: $('.blog-article-slider-wrapper .styled_slider_arrow--right'),
            appendDots: $(".blog-article-slider-wrapper .slider_flat_dots"),
            responsive: [{
                    breakpoint: 1270,
                    settings: {
                        slidesToScroll: 2,
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 680,
                    settings: {
                        slidesToScroll: 1,
                        slidesToShow: 1,
                        centerMode: true,
                    }
                }
            ]
        });
    }

    if ($("#google_review_slider").length) {
        // review slider
        $('#google_review_slider .google_review_slider').slick({
            infinite: true,
            dots: true,
            arrows: true,
            slidesToScroll: 3,
            swipeToSlide: true,
            slidesToShow: 3,
            variableWidth: true,
            prevArrow: $('#google_review_slider .styled_slider_arrow--left'),
            nextArrow: $('#google_review_slider .styled_slider_arrow--right'),
            appendDots: $("#google_review_slider .slider_flat_dots"),
            responsive: [{
                    breakpoint: 1270,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 680,
                    settings: {
                        slidesToScroll: 1,
                        slidesToShow: 1,
                        centerMode: true,
                    }
                }
            ]
        });

        $('.review__more').on('click', function () {
            $(this).closest('.google_review').css('height', 'auto');
            $(this).closest('.google_review').find('.review__text').css('height', 'auto');
            $(this).text('');
        });
    }

    if ($("#review_slider").length) {
        // review slider
        $('#review_slider .review_slider').slick({
            infinite: true,
            dots: true,
            arrows: true,
            slidesToScroll: 3,
            swipeToSlide: true,
            slidesToShow: 3,
            variableWidth: true,
            prevArrow: $('#review_slider .styled_slider_arrow--left'),
            nextArrow: $('#review_slider .styled_slider_arrow--right'),
            appendDots: $("#review_slider .slider_flat_dots"),
            responsive: [{
                    breakpoint: 1270,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 680,
                    settings: {
                        slidesToScroll: 1,
                        slidesToShow: 1,
                        centerMode: true,
                    }
                }
            ]
        });
    }

    if ($("#advantages").length) {
        // car slider 1
        $('#advantages .items_slider').slick({
            infinite: true,
            dots: true,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            // variableWidth: true,
            prevArrow: $('#advantages .styled_slider_arrow--left'),
            nextArrow: $('#advantages .styled_slider_arrow--right'),
            appendDots: $("#advantages .slider_flat_dots"),
        });
    }

    // select 2 init
    $('.select2-container').not('.select2-multiple2').select2();

    // Google Translate nesmí překládat filtr značky/modelu – přeložený text optionu
    // se jinak propíše do URL výpisu. Označíme původní selecty (i AJAX doplněné
    // optiony modelu) a select2 container/dropdown, které vznikají dynamicky.
    markBrandModelNoTranslate($('select.selectZnacka, select.selectModel'));


    $('[data-toggle="popover"]').popover({
        container: 'body'
    });

    $('.enableSliderArticle').slick({
        autoplay: true,
        autoplaySpeed: $('.enableSliderArticle').data('speed') * 1000,
        dots: true
    });

    $('input[type=file].nice_file').change(function (e) {
        var id = $(this).attr('id');
        var filename = $(this).val().split('\\').pop();
        var count = $(this).get(0).files.length;

        if (count < 1) {
            $(".fileName." + id).text(filename);
        } else if (count < 2) {
            $(".fileName." + id).text(filename);
        } else {
            var fileText = 'soubory';
            if (count > 4) {
                fileText = 'souborů';
            }
            $(".fileName." + id).text(count + ' ' + fileText);
        }
    });

    // if (location.search.indexOf("step=") >= 0) {
    //     if ($(".scrollToStep").length) {
    //         setTimeout(function () {
    //             var scrollTop = 0;
    //             if ($(window).width()>700 || !$(".scrollToStepMobile").length){
    //                 scrollTop = $(".scrollToStep").offset().top - $(".scrollToStep").data('minus');
    //             }else{
    //                 scrollTop = $(".scrollToStepMobile").offset().top - $(".scrollToStepMobile").data('minus');
    //             }
    //
    //             $('html, body').animate({
    //                 scrollTop: scrollTop
    //             }, 300);
    //         }, 1000);
    //     }
    // }
};

App.prototype.initCountdown = function () {
    if ($(".countdown_item").not('.is-countdown').length) {
        var newYear = new Date();
        $(".countdown_item").not('.is-countdown').each(function (index) {
            var date_to = $(this).attr("data-countdown-to");
            newYear = new Date(date_to);
            $(this).countdown({
                until: newYear
            });
        });
    }

    // Nový countdown pro progress_circles
    if ($(".progress_circles").length) {
        function updateProgressCircles() {
            $(".progress_circles").each(function () {
                var $circles = $(this);
                var date_to = $circles.attr("data-countdown-to");

                if (!date_to) {
                    return;
                }

                var endDate = new Date(date_to);
                var now = new Date();

                if (now >= endDate) {
                    // Akce již skončila
                    $circles.find(".progress_number").text("00");
                    $circles.find(".progress_wrapper").css("--percent", "0");
                    return;
                }

                // Výpočet zbývajícího času
                var diff = Math.floor((endDate - now) / 1000); // rozdíl v sekundách

                var days = Math.floor(diff / (24 * 60 * 60));
                diff -= days * 24 * 60 * 60;

                var hours = Math.floor(diff / (60 * 60));
                diff -= hours * 60 * 60;

                var minutes = Math.floor(diff / 60);

                // Výpočet procent
                var dayPercent, hourPercent, minPercent;

                // Pro dny - předpokládáme 30 dní jako maximum, nebo získat z atributu
                var maxDays = parseInt($circles.attr("data-max-days") || "30");
                dayPercent = Math.min(100, Math.max(0, (days * 100) / maxDays));

                // Pro hodiny a minuty - fixní maxima
                hourPercent = Math.min(100, Math.max(0, (hours * 100) / 24));
                minPercent = Math.min(100, Math.max(0, (minutes * 100) / 60));

                // Aktualizace UI
                $circles.find(".progress_wrapper").eq(0).css("--percent", dayPercent);
                $circles.find(".progress_wrapper").eq(1).css("--percent", hourPercent);
                $circles.find(".progress_wrapper").eq(2).css("--percent", minPercent);

                $circles.find(".progress_wrapper").eq(0).find(".progress_number").text(days < 10 ? "0" + days : days);
                $circles.find(".progress_wrapper").eq(1).find(".progress_number").text(hours < 10 ? "0" + hours : hours);
                $circles.find(".progress_wrapper").eq(2).find(".progress_number").text(minutes < 10 ? "0" + minutes : minutes);
            });
        }

        // Spustit aktualizaci hned a pak každou minutu
        updateProgressCircles();
        setInterval(updateProgressCircles, 60000);
    }
}

App.prototype.destroyCountdown = function () {
    if ($(".countdown_item.is-countdown").length) {
        $(".countdown_item.is-countdown").countdown('destroy');
    }
}

App.prototype.initNotifications = function () {
    if ($('#cookieUseAgreement').length > 0) {
        $('#cookieUseAgreement button').off('click').on('click', function () {
            var date = new Date();
            date.setFullYear(date.getFullYear() + 10);
            if (window.location.host === 'www.skodovky.cz') {
                document.cookie = 'eu-cookies=1; path=/; domain=.skodovky.cz; expires=' + date.toGMTString();
            } else if (window.location.host === 'www.skodovky.loc') {
                document.cookie = 'eu-cookies=1; path=/; domain=.skodovky.loc; expires=' + date.toGMTString();
            } else if (window.location.host === 'www.dodavky-esa.cz') {
                document.cookie = 'eu-cookies=1; path=/; domain=.dodavky-esa.cz; expires=' + date.toGMTString();
            } else if (window.location.host === 'www.dodavky-esa.cz') {
                document.cookie = 'eu-cookies=1; path=/; domain=.dodavky-esa.loc; expires=' + date.toGMTString();
            } else if (window.location.host === 'www.autoesaeu.loc') {
                document.cookie = 'eu-cookies=1; path=/; domain=.autoesaeu.loc; expires=' + date.toGMTString();
            } else if (window.location.host === 'www.autoesa.eu') {
                document.cookie = 'eu-cookies=1; path=/; domain=.autoesa.eu; expires=' + date.toGMTString();
            } else if (window.location.host === 'www.autoesa.loc') {
                document.cookie = 'eu-cookies=1; path=/; domain=.autoesa.loc; expires=' + date.toGMTString();
            } else {
                document.cookie = 'eu-cookies=1; path=/; domain=.autoesa.cz; expires=' + date.toGMTString();
            }
            $('#cookieUseAgreement').hide();
        });
    }


    var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    var date = new Date();
    date.setHours(date.getHours() + 4);
    var expire = 'expires=' + (isChrome ? date.toGMTString() : 0);

    if ($('#infoText').length > 0) {
        $('#infoText button').off('click').on('click', function () {
            if (window.location.host === 'www.skodovky.cz') {
                document.cookie = 'info-text2=1; path=/; domain=.skodovky.cz; ' + expire;
            } else if (window.location.host === 'www.skodovky.loc') {
                document.cookie = 'info-text=1; path=/; domain=.skodovky.loc; ' + expire;
            } else if (window.location.host === 'www.dodavky-esa.cz') {
                document.cookie = 'info-text=1; path=/; domain=.dodavky-esa.cz; ' + expire;
            } else if (window.location.host === 'www.dodavky-esa.cz') {
                document.cookie = 'info-text=1; path=/; domain=.dodavky-esa.loc; ' + expire;
            } else if (window.location.host === 'www.autoesaeu.loc') {
                document.cookie = 'info-text=1; path=/; domain=.autoesaeu.loc; ' + expire;
            } else if (window.location.host === 'www.autoesa.eu') {
                document.cookie = 'info-text=1; path=/; domain=.autoesa.eu; ' + expire;
            } else if (window.location.host === 'www.autoesa.loc') {
                document.cookie = 'info-text=1; path=/; domain=.autoesa.loc; ' + expire;
            } else {
                document.cookie = 'info-text=1; path=/; domain=.autoesa.cz; ' + expire;
            }
            $('#infoText').hide();
        });

        $(window).scroll(function () {
            $('#infoText').css('bottom', -$(window).scrollTop());
        });
    }


    if ($('#infoText2').length > 0) {
        $('#infoText2 button').off('click').on('click', function () {
            var date = new Date();
            date.setDate(date.getDate() + 3);
            if (window.location.host === 'www.skodovky.cz') {
                document.cookie = 'info-text2=1; path=/; domain=.skodovky.cz; ' + expire;
            } else if (window.location.host === 'www.skodovky.loc') {
                document.cookie = 'info-text2=1; path=/; domain=.skodovky.loc; ' + expire;
            } else if (window.location.host === 'www.dodavky-esa.cz') {
                document.cookie = 'info-text2=1; path=/; domain=.dodavky-esa.cz; ' + expire;
            } else if (window.location.host === 'www.dodavky-esa.cz') {
                document.cookie = 'info-text2=1; path=/; domain=.dodavky-esa.loc; ' + expire;
            } else if (window.location.host === 'www.autoesaeu.loc') {
                document.cookie = 'info-text2=1; path=/; domain=.autoesaeu.loc; ' + expire;
            } else if (window.location.host === 'www.autoesa.eu') {
                document.cookie = 'info-text2=1; path=/; domain=.autoesa.eu; ' + expire;
            } else if (window.location.host === 'www.autoesa.loc') {
                document.cookie = 'info-text2=1; path=/; domain=.autoesa.loc; ' + expire;
            } else {
                document.cookie = 'info-text2=1; path=/; domain=.autoesa.cz; ' + expire;
            }
            $('#infoText2').hide();
        });

        $(window).scroll(function () {
            $('#infoText2').css('bottom', -$(window).scrollTop());
        });
    }

    if ($('.top-notification').length > 0) {
        $('.top-notification button').off('click').on('click', function () {
            var date = new Date();
            date.setDate(date.getDate() + 1);
            if (window.location.host === 'www.skodovky.cz') {
                document.cookie = 'top-notification=1; path=/; domain=.skodovky.cz; ' + expire;
            } else if (window.location.host === 'www.skodovky.loc') {
                document.cookie = 'top-notification=1; path=/; domain=.skodovky.loc; ' + expire;
            } else if (window.location.host === 'www.dodavky-esa.cz') {
                document.cookie = 'top-notification=1; path=/; domain=.dodavky-esa.cz; ' + expire;
            } else if (window.location.host === 'www.dodavky-esa.cz') {
                document.cookie = 'top-notification=1; path=/; domain=.dodavky-esa.loc; ' + expire;
            } else if (window.location.host === 'www.autoesaeu.loc') {
                document.cookie = 'top-notification=1; path=/; domain=.autoesaeu.loc; ' + expire;
            } else if (window.location.host === 'www.autoesa.eu') {
                document.cookie = 'top-notification=1; path=/; domain=.autoesa.eu; ' + expire;
            } else if (window.location.host === 'www.autoesa.loc') {
                document.cookie = 'top-notification=1; path=/; domain=.autoesa.loc; ' + expire;
            } else {
                document.cookie = 'top-notification=1; path=/; domain=.autoesa.cz; ' + expire;
            }
            $('.top-notification').remove();
        });
    }
}

App.prototype.prependOverlayContent = function () {
    if ($('.overlayContent').length && !$('.overlayContent .loader-wrapper').length) {
        var html = '<div class="loader-wrapper"><div class="loader-circle-wrapper"><div class="loader-circle"></div></div></div>';
        $('.overlayContent').prepend(html);
        $('.animateAjaxSearch').prop("disabled", true);
    }
};

App.prototype.initGMap = function () {
    if ($('.map').length) {
        $.nette.ajax({
            type: 'GET',
            url: '/?do=getBranchesJson',
            success: function (payload) {
                const map = L.map('g-map').setView([50.0755, 14.4378], 13); // Praha jako výchozí bod

                // Přidání dlaždic z Mapy.cz
                const API_KEY = '31MPD4TcjNkM5--ihBBywH0Vrbe0LE5xatqXc8jOi2w';
                L.tileLayer('https://api.mapy.cz/v1/maptiles/basic/256/{z}/{x}/{y}?apikey=' + API_KEY, {
                    attribution: '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a další</a>'
                }).addTo(map);

                const bounds = [];

                // Iterace přes branch data
                $.each(payload, function (index, region) {
                    $.each(region, function (index2, branch) {
                        console.log(branch);
                        const markerData = {
                            lat: branch.gpsx,
                            lng: branch.gpsy
                        };


                        var markerIcon = L.icon({
                            iconUrl: '/images/marker.png',
                            iconSize: [41, 53],
                            iconAnchor: [20.5, 53],
                            popupAnchor: [0, -53]
                        });

                        // if (branch.big === '1') {
                        //     var markerIcon = L.icon({
                        //         iconUrl: '/images/marker_big.png',
                        //         iconSize: [72, 92],
                        //         iconAnchor: [36, 92],
                        //         popupAnchor: [0, -92]
                        //     });
                        // }

                        const marker = L.marker([markerData.lat, markerData.lng], {
                                icon: markerIcon
                            })
                            .addTo(map)
                            .bindPopup(
                                `<div class="map-popup">
                                    <p class="map-popup-title"><b>Auto ESA</b> ${branch.nazev}</p>
                                    <p class="map-popup-count">${branch.pocetVozu} prověřených vozů</p>
                                    <p class="map-popup-opening">${branch.oteviraciDoba}</p>
                                    <p class="map-popup-address">${branch.ulice}, ${branch.mesto}</p>
                                    <p class="map-popup-link"><a href="${branch.odkazDoGoogleMaps}" target="_blank">Navigovat</a></p>
                                </div>`
                            );

                        bounds.push([markerData.lat, markerData.lng]);
                    });
                });

                // Automatické přizpůsobení mapy dle markerů
                if (bounds.length) {
                    map.fitBounds(bounds);
                }

                // Přidání loga Mapy.cz jako kontrola
                const LogoControl = L.Control.extend({
                    options: {
                        position: 'bottomleft'
                    },
                    onAdd: function () {
                        const container = L.DomUtil.create('div', 'leaflet-control-logo');
                        const link = L.DomUtil.create('a', '', container);

                        link.setAttribute('href', 'http://mapy.cz/');
                        link.setAttribute('target', '_blank');
                        link.innerHTML = '<img src="https://api.mapy.cz/img/api/logo.svg" alt="Mapy.cz logo"/>';
                        return container;
                    }
                });

                map.addControl(new LogoControl());
            }
        });
    }
};

App.prototype.initMapMarkers = function () {
    // GPS souřadnice hranic ČR pro výpočet
    const GPS_BOUNDS = {
        north: 51.0557,  // Severní bod ČR
        south: 48.5518,  // Jižní bod ČR
        west: 12.0905,   // Západní bod ČR
        east: 18.8592    // Východní bod ČR
    };

    $('.branches__map_static .marker').each(function() {
        const $marker = $(this);
        const gpsX = parseFloat($marker.data('gps-x')); // Latitude
        const gpsY = parseFloat($marker.data('gps-y')); // Longitude

        // Převod GPS na procenta
        const percentY = ((gpsY - GPS_BOUNDS.west) / (GPS_BOUNDS.east - GPS_BOUNDS.west)) * 100;
        const percentX = ((GPS_BOUNDS.north - gpsX) / (GPS_BOUNDS.north - GPS_BOUNDS.south)) * 100;

        // Umístění markeru s kompenzací velikosti (41x53px)
        $marker.css({
            'left': 'calc(' + percentY + '% - 20.5px)',  // 41px / 2
            'top': 'calc(' + percentX + '% - 53px)'      // celá výška markeru
        });
    });

    // Click handler pro zobrazení popupu
    $('.branches__map_static .marker').off('click').on('click', function(e) {
        e.stopPropagation();

        const $marker = $(this);
        const $popup = $marker.find('.map-popup-content');
        const $mapContainer = $('.branches__map_static');

        // Zavřít ostatní popupy
        $('.branches__map_static .marker').not(this).removeClass('marker--active');

        // Toggle aktivního markeru
        $marker.toggleClass('marker--active');

        // Pokud se otevírá popup, zkontroluj pozici
        if ($marker.hasClass('marker--active')) {
            // Počkej na dokončení CSS transition
            setTimeout(function() {
                adjustPopupPosition($marker, $popup, $mapContainer);
            }, 10);
        }
    });

    // Zavření popupu při kliknutí mimo
    $(document).on('click', function(e) {
        if (!$(e.target).closest('.marker').length) {
            $('.marker').removeClass('marker--active');
        }
    });
}


App.prototype.initScrollNav = function () {


    if ($('.detail2__bottom__nav').length) // use this if you are using id to check
    {
        var lastId,
            topMenu = $(".detail2__bottom__nav"),
            topMenuHeight = topMenu.outerHeight() + 15,
            // All list items
            menuItems = topMenu.find("a"),
            // Anchors corresponding to menu items
            scrollItems = menuItems.map(function () {
                if ($(this).attr("href") !== '#') {
                    var item = $($(this).attr("href"));
                    if (item.length) {
                        return item;
                    }
                }
            });

        // Bind click handler to menu items
        // so we can get a fancy scroll animation
        menuItems.click(function (e) {
            var href = $(this).attr("href");
            if (href === '#rezervace') {
                $('#detail_rezervovat').trigger('click');
            } else {
                var offsetTop = href === "#" ? 0 : $(href).offset().top - parseInt($(".detail_fixed_content").height()) + 1;
                $('html, body').stop().animate({
                    scrollTop: offsetTop
                }, 300);
                e.preventDefault();
            }
        });

        // Bind to scroll
        $(window).scroll(function () {
            // Get container scroll position
            var fromTop = $(this).scrollTop() + parseInt($(".detail_fixed_content").height());

            // Get id of current scroll item
            var cur = scrollItems.map(function () {
                if ($(this).offset().top < fromTop + 80)
                    return this;
            });
            // Get the id of the current element
            cur = cur[cur.length - 1];
            var id = cur && cur.length ? cur[0].id : "";

            if (lastId !== id) {
                lastId = id;
                // Set/remove active class
                menuItems
                    .parent().removeClass("active")
                    .end().filter("[href='#" + id + "']").parent().addClass("active");
            }
        });

        // show hide buttons

        console.log('car-detail-buttons');
        var buttonsEl = $(".car-detail-buttons");

        $(window).scroll(function () {
            // Get container scroll position
            var elFromTop = parseInt($(".car_buttons").offset().top) + parseInt($(".car_buttons").height());
            var fromTop = parseInt($(this).scrollTop());

            if (fromTop > elFromTop) {
                buttonsEl.show();
            } else {
                buttonsEl.hide();
            }
        });

    }
};

App.prototype.initTippy = function () {
    tippy('.info-block', {
        placement: 'top',
        allowHTML: true,
        content: function (reference) {
            return $($(reference).data('template')).html();
        },
    });
}

App.prototype.initKoop = function () {
    this.initShowContentBySelectOption();
    this.initShowContentByRadioList();
    this.initShowContentByCheckbox();
    this.initShowContentByCheckbox2();
    this.initShowContentByCheckbox3();
    this.initShowContentByCheckbox4();

    $(".showCarValue input").off('change').on('change', function () {
        if ($(this).data('show-car-value')) {
            $('#formSWC_2_3').removeClass('d-none');
        } else {
            $('#formSWC_2_3').addClass('d-none');
        }
    });
}

App.prototype.initShowContentBySelectOption = function () {
    $(".showContentBySelectOption").on('change', function () {
        $(this).closest('.content-class-container').find('.content-class').addClass('d-none');
        $(this).closest('.content-class-container').find('.' + $(this).find('option[value="' + $(this).val() + '"]').data("show-class")).removeClass('d-none');
    });
};

App.prototype.initShowContentByRadioList = function () {
    $(".showContentByRadioList input[type=radio]").on('change', function () {
        $(this).closest('.radio-show-container').find('.radio-show').addClass('d-none');
        console.log($(this).data("show-class"));
        $(this).closest('.radio-show-container').find('.' + $(this).data("show-class")).removeClass('d-none');
    });
};

App.prototype.initShowContentByCheckbox = function () {
    $(".showContentByCheckbox").on('change', function () {
        $(this).closest('.check-show-container').find('.check-show').addClass('d-none');
        var selector = '.check-show-' + (this.checked ? '1' : '2');
        $(this).closest('.check-show-container').find(selector).removeClass('d-none');
    });
};

App.prototype.initShowContentByCheckbox2 = function () {
    $(".showContentByCheckbox2").on('change', function () {
        $(this).closest('.check-show-container2').find('.check-show2').addClass('d-none');
        var selector = '.check-show2-' + (this.checked ? '1' : '2');
        $(this).closest('.check-show-container2').find(selector).removeClass('d-none');
    });
};

App.prototype.initShowContentByCheckbox3 = function () {
    $(".showContentByCheckbox3").on('change', function () {
        $(this).closest('.check-show-container3').find('.check-show3').addClass('d-none');
        var selector = '.check-show3-' + (this.checked ? '1' : '2');
        $(this).closest('.check-show-container3').find(selector).removeClass('d-none');
    });
};

App.prototype.initShowContentByCheckbox4 = function () {
    $(".showContentByCheckbox4").on('change', function () {
        $(this).closest('.check-show-container4').find('.check-show4').removeClass('d-none');
        var selector = '.check-show4-' + (this.checked ? '1' : '2');
        $(this).closest('.check-show-container4').find(selector).addClass('d-none');
    });
};

App.prototype.showCebiaPopup = function () {
    var elPopup = $("#popup-cebia");
    elPopup.fadeIn();

    var currentUrl = window.location.origin + window.location.pathname;
    var newUrl = currentUrl + "#cebia";
    window.history.replaceState(null, null, newUrl);

    // dataLayer.push(dataexp_view_item);

    elPopup.find("#popup-cebia-close").off('click').on('click', function () {
        elPopup.fadeOut();
        if (elPopup.find(".sendCebia").length) {
            elPopup.find(".sendCebia").trigger('click');
        }
    });

    elPopup.off('click').on('click', function (event) {
        if (event.target === this) {
            $(this).fadeOut();
            if (elPopup.find(".sendCebia").length) {
                elPopup.find(".sendCebia").trigger('click');
            }
        }
    });
};

App.prototype.initPopupCebia = function () {
    var self = this;
    $(".popup-cebia-show").off('click').on('click', function () {
        self.showCebiaPopup();
    });

    $(".popup-cebia-show-wrapper").off('click').on('click', function () {
        if ($(this).find(".popup-cebia-show").length) {
            self.showCebiaPopup();
        }
    });
};

App.prototype.initPopupCo2 = function () {
    $(".popup-co2-show").click(function () {
        $("#popup-co2").fadeIn();

        // var currentUrl = window.location.origin + window.location.pathname;
        // var newUrl = currentUrl + "#co2";
        // window.history.replaceState(null, null, newUrl);
        //
        // dataLayer.push(dataview_item);
    });

    $("#popup-co2-close").click(function () {
        $("#popup-co2").fadeOut();
    });

    $("#popup-co2").click(function (event) {
        if (event.target === this) {
            $(this).fadeOut();
        }
    });

    updateChart();

    $('#years, #annualMileage').on('change', function () {
        updateChart();
    });

    function updateChart() {
        const years = parseInt($('#years').val());
        const annualMileage = parseInt($('#annualMileage').val());

        const CO2Production = ($('.calculator').data('co2') * (annualMileage * years)) * 0.000001;

        const chart = $('.chart');
        chart.empty();

        const maxCO2 = 50;
        const numBars = 40;
        const maxHeight = 92;
        const minHeight = 36;

        const expBase = 1.05;
        const step = (maxHeight - minHeight) / (Math.pow(expBase, numBars) - 1);

        for (let i = 0; i < numBars; i++) {
            const bar = $('<div class="bar"></div>');
            const height = minHeight + step * (Math.pow(expBase, i) - 1);
            bar.css('height', height + 'px');

            if (i + 1 <= CO2Production / maxCO2 * numBars) {
                bar.addClass('green');
            }

            chart.append(bar);
        }

        $('.result-co2').html(CO2Production);
    }
};